export default {
  countryCode: 'UK',
  regionLinks: [
    {
      title: 'London',
    },
    {
      title: 'Bristol',
    },
    {
      title: 'Bath',
    },
    {
      title: 'Cardiff',
    },
    {
      title: 'Birmingham',
    },
    {
      title: 'Redditch',
    },
    {
      title: 'Manchester',
    },
    {
      title: 'Glasgow',
    },
    {
      title: 'Edinburgh',
    },
    {
      title: 'Newcastle upon Tyne',
      slug: '/newcastle/',
    },
    {
      title: 'Nottingham',
    },
    {
      title: 'Sheffield',
    },
    {
      title: 'Liverpool',
    },
    {
      title: 'Leeds',
    },
    {
      title: 'Belfast',
    },
    {
      title: 'Brighton',
    },
    {
      title: 'Newport',
    },
  ],
};
